module.exports = __webpack_public_path__ + "img/topv.41e01007.png";